/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const PaymentVoucherStatus = {
  edit: {
    name: 'แก้ไขข้อมูล',
    color: 'warning',
    icon: 'border_color',
  },
  invoice: {
    name: 'วางบิล',
    color: 'info',
    icon: 'task_alt',
  },
  paid: {
    name: 'ชำระเงิน',
    color: 'success',
    icon: 'task_alt',
  },
  shipping: {
    name: 'ส่งสินค้า',
    color: 'success',
    icon: 'task_alt',
  },
  reject: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default PaymentVoucherStatus;
